import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerAbout'; 
import Histoty from './History';
import AboutHistory from './AboutHistory';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutHistory />
        <Histoty />
      </div>
    );
  };
  
  export default About;
  